module.exports = __webpack_public_path__ + "static/DSC_9410-29bf42a898c06a0cae50c3a304a8e665.jpg";